import React from "react";
import "./PrintTracking.scss";
import {hscLogo, striveLogo} from "../../consts/consts";

let findIndex = require('lodash.findindex');

const noPropertiesPerPage = 5;

export default class PrintTracking extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
        };
    }

    static renderHeader(pageNo, title) {
        const d = new Date();
        const date = d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
        const isHsc = title && title.toUpperCase().includes('HSC');

        return (
            <div className='header'>
                <div className='float_left'>
                    <h3 className='PrintTracking_h3'>{title}</h3>
                    <h4 className='PrintTracking_h4'>{date} - Pg. {pageNo}</h4>
                </div>
                <div className={`logo ${isHsc ? 'hsc' : ''} float_right`}>
                    <img src={arc.path.media+(isHsc ? hscLogo : striveLogo)} alt=''/>
                </div>
            </div>
        )
    }

    static getCell(task, element) {
        switch(task.type) {
            case 'date': {
                const checked = element[task.id + '_CHECKBOX'];
                return (
                    <div className='PrintTracking_date_wrapper'>
                        <div className='date'>{element[task.id] || '-'}</div>
                        <input name={`${element.ARCIMEDES_ROW_ID}-${task.id}_CHECKBOX`} className="PrintTracking_date_checkbox" type="checkbox" checked={checked} disabled/>
                    </div>
                )
            }
            case 'empty':
                return;
            case 'borrower':
                return element['BORROWER_NAME'] || '-';
            default: {
                return element[task.id] || '-';
            }
        }
    }

    static renderTable(tasks, data, totalProperties, pageNo, notFull, title) {
        return (
            <React.Fragment>
                {PrintTracking.renderHeader(pageNo, title)}
                <table key={Math.random()} className='table' style={{width: notFull ? `${100 - 14 * (noPropertiesPerPage - data.length)}%` : '100%'}}>
                    <thead>
                        <tr>
                            <th className='PrintTracking_th'>
                                Task {data.length > 1 ? `- ${totalProperties} Properties in Escrow` : ''}
                            </th>
                            {
                                data.map(row => {
                                    const index = row.TASK.lastIndexOf('-');
                                    const name = row.TASK ? row.TASK.slice(0, index - 1) : 'N/A';
                                    const city = row.TASK ? row.TASK.slice(index + 2, row.TASK.length) : 'N/A';
                                    return (
                                        <th className='PrintTracking_th center' key={row.ARCIMEDES_ROW_ID}>
                                            {name}<br/>{city}
                                        </th>
                                    );
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                    {
                        tasks.map(task => {
                            return (
                                <tr key={task.id}>
                                    <th className={`PrintTracking_th ${task.isSubTask ? 'subtask' : ''} ${task.highlighted ? 'Tracking_highlighted' : ''}`}>
                                        {task.step && `${task.step}. `}{task.name}
                                    </th>
                                    {
                                        data ? data.map((element, index) => {
                                            const isGray = index % 2;
                                            return (
                                                <td className={`PrintTracking_td ${task.highlighted ? 'highlighted' : (isGray ? 'gray': '')}`} key={element.ARCIMEDES_ROW_ID}>
                                                    {PrintTracking.getCell(task, element)}
                                                </td>
                                            );
                                        }) : ''
                                    }
                                </tr>
                            );
                        })
                    }
                    </tbody>
                </table>
            </React.Fragment>
        )
    }

    static renderPages(data, tasks, splitTaskId, title) {
        let pageIndex = 0;
        const noTables = Math.ceil(data.length / noPropertiesPerPage);
        if (!noTables) return;

        let firstTasks, secondTasks;
        if (splitTaskId) {
            const indexSplitTask = findIndex(tasks, {id: splitTaskId});
            firstTasks = tasks.slice(0, indexSplitTask);
            secondTasks = tasks.slice(indexSplitTask);
        } else {
            firstTasks = tasks;
        }

        return (
            [...Array(noTables)].map((value, index) => {
                const properties = data.slice(pageIndex, pageIndex + noPropertiesPerPage);
                const pageNo = splitTaskId ? index * 2 + 1 : index + 1;
                const notFull = !!(properties.length < noPropertiesPerPage);
                pageIndex += noPropertiesPerPage;

                return (
                    <React.Fragment key={index}>
                        {PrintTracking.renderTable(firstTasks, properties, data.length, pageNo, notFull, title)}
                        {splitTaskId && PrintTracking.renderTable(secondTasks, properties, data.length, pageNo + 1, notFull, title)}
                    </React.Fragment>
                );
            })
        );
    }

    render() {
        const {data, tasks, splitTaskId, title} = this.props;

        return (
            <div className="PrintTracking">
                {PrintTracking.renderPages(data, tasks, splitTaskId, title)}
            </div>
        )
    }
}
